/* DentalWipes landing page interactivity */
(function () {
  'use strict';

  var TEAL = 'rgb(42, 181, 181)';

  /* ---------- Scroll reveal (fade/slide-in) ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!els.length) return;
    function revealAll() { els.forEach(function (el) { el.classList.add('revealed'); }); }
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(revealAll, 2500); // safety net: never leave content hidden
  }

  /* ---------- Product image gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-dw-main-image]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-dw-thumb]'));
    if (!main || !thumbs.length) return;

    function activate(idx) {
      idx = (idx + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, i) {
        var on = i === idx;
        t.style.border = on ? '2px solid ' + TEAL : '2px solid transparent';
        t.style.opacity = on ? '1' : '0.6';
        t.setAttribute('data-dw-active', on ? 'true' : 'false');
      });
      var img = thumbs[idx].querySelector('img');
      if (img) { main.style.opacity = '0'; setTimeout(function () { main.src = img.src; main.alt = img.alt || main.alt; main.style.opacity = '1'; }, 120); }
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { activate(i); }); });

    // Mark the first thumb active on load so the prev/next arrows have a starting point.
    if (!thumbs.some(function (t) { return t.getAttribute('data-dw-active') === 'true'; })) {
      thumbs[0].setAttribute('data-dw-active', 'true');
    }
    function currentIndex() {
      var cur = thumbs.findIndex(function (t) { return t.getAttribute('data-dw-active') === 'true'; });
      return cur < 0 ? 0 : cur;
    }

    var next = document.querySelector('[data-dw-gallery-next]');
    if (next) next.addEventListener('click', function () { activate(currentIndex() + 1); });

    var prev = document.querySelector('[data-dw-gallery-prev]');
    if (prev) prev.addEventListener('click', function () { activate(currentIndex() - 1); });
  }

  /* ---------- FAQ accordion (single open) ---------- */
  var PLUS = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus" style="color: rgb(107, 114, 128);"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';
  var MINUS = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus" style="color: #fff;"><path d="M5 12h14"></path></svg>';

  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-dw-faq]'));
    if (!items.length) return;

    function setState(item, open) {
      var btn = item.querySelector('[data-dw-faq-toggle]');
      var q = item.querySelector('[data-dw-faq-q]');
      var icon = item.querySelector('[data-dw-faq-icon]');
      var ans = item.querySelector('[data-dw-faq-answer]');
      if (open) {
        btn.style.backgroundColor = 'rgb(13, 27, 42)';
        q.style.color = '#fff';
        icon.style.backgroundColor = TEAL;
        icon.innerHTML = MINUS;
        ans.style.display = 'block';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.style.backgroundColor = 'rgb(255, 255, 255)';
        q.style.color = 'rgb(13, 27, 42)';
        icon.style.backgroundColor = 'rgb(243, 244, 246)';
        icon.innerHTML = PLUS;
        ans.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-dw-faq-toggle]');
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        items.forEach(function (other) { setState(other, false); });
        if (!isOpen) setState(item, true);
      });
    });
  }

  /* ---------- Bundle (offer) selection ---------- */
  function initBundles() {
    var radios = Array.prototype.slice.call(document.querySelectorAll('input[name="offer"]'));
    if (!radios.length) return;
    var priceEl = document.querySelector('[data-dw-price]');
    var compareEl = document.querySelector('[data-dw-compare]');
    var saveEl = document.querySelector('[data-dw-save]');
    var stickyPriceEls = Array.prototype.slice.call(document.querySelectorAll('[data-dw-sticky-price]'));
    var stickyCompareEls = Array.prototype.slice.call(document.querySelectorAll('[data-dw-sticky-compare]'));
    function paint() {
      radios.forEach(function (r) {
        var label = r.closest('label');
        if (!label) return;
        if (r.checked) {
          label.style.backgroundColor = 'rgb(240, 250, 250)';
          label.style.border = '2px solid ' + TEAL;
        } else {
          label.style.backgroundColor = 'rgb(255, 255, 255)';
          label.style.border = '2px solid rgb(226, 232, 240)';
        }
      });
      // Sync the price under the title with the selected pack
      var sel = radios.filter(function (r) { return r.checked; })[0];
      if (sel) {
        var p = sel.getAttribute('data-price');
        var c = sel.getAttribute('data-compare');
        var sv = sel.getAttribute('data-save');
        if (priceEl && p) priceEl.textContent = p;
        if (compareEl && c) compareEl.textContent = c;
        if (saveEl && sv) saveEl.textContent = sv;
        // Keep the sticky buy-bar price in sync too
        if (p) stickyPriceEls.forEach(function (el) { el.textContent = p; });
        if (c) stickyCompareEls.forEach(function (el) { el.textContent = c; });
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', paint); });
    paint();
  }

  /* ---------- Sticky buy bar (mobile) — show after hero ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-dw-sticky-bar]');
    var hero = document.getElementById('product-info');
    if (!bar || !hero) return;
    function onScroll() {
      var past = hero.getBoundingClientRect().bottom < 0;
      bar.style.transform = past ? 'translateY(0)' : 'translateY(100%)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Buy now → straight to checkout via cart permalink ---------- */
  function initCart() {
    var btn = document.querySelector('[data-dw-atc]');
    if (!btn) return;
    var originalHTML = btn.innerHTML;
    function resetBtn() {
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
      btn.innerHTML = originalHTML;
    }
    btn.addEventListener('click', function () {
      var checked = document.querySelector('input[name="offer"]:checked');
      var variantId = (checked && checked.getAttribute('data-variant-id')) || btn.getAttribute('data-default-variant') || '';
      variantId = variantId.trim();
      if (!variantId) { window.location.href = ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart'; return; }
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
      btn.textContent = 'Processing…';
      // Cart permalink: loads the selected pack and goes straight to checkout
      // (append ?storefront=true to land on the cart page instead).
      window.location.href = ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart/' + encodeURIComponent(variantId) + ':1';
    });
    // If the visitor returns via browser back/forward (bfcache restore), the
    // button would otherwise stay frozen on "Processing…" — restore it.
    window.addEventListener('pageshow', resetBtn);
  }

  /* ---------- Buy-box tabs (Benefits / Usage / Ingredients) ---------- */
  function initTabs() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-dw-tab]'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-dw-tab-panel]'));
    if (!btns.length) return;
    function activate(key) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-dw-tab') === key;
        b.style.background = on ? 'rgb(13, 27, 42)' : 'rgb(255, 255, 255)';
        b.style.color = on ? 'rgb(255, 255, 255)' : 'rgb(107, 114, 128)';
      });
      panels.forEach(function (p) { p.style.display = p.getAttribute('data-dw-tab-panel') === key ? '' : 'none'; });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { activate(b.getAttribute('data-dw-tab')); }); });
  }

  /* ---------- Ingredient selector ---------- */
  var INGREDIENTS = [
    { icon: '🍃', name: 'Tea Polyphenols', description: 'Powerful antioxidants from green tea that tackle plaque, tartar, and bad breath right at the source.', benefits: ['Reduces plaque buildup', 'Fights the bacteria that cause bad breath', 'Supports healthy gums'] },
    { icon: '🛡️', name: 'CPC (Cetylpyridinium Chloride)', description: 'A proven antibacterial agent that kills harmful bacteria and helps prevent new plaque from forming.', benefits: ['Kills 99% of mouth bacteria', 'Prevents new plaque', 'Clinically tested and safe'] },
    { icon: '🍋', name: 'Citric Acid', description: 'Helps soften and loosen existing tartar while supporting fresh breath.', benefits: ['Breaks down tartar', 'Supports fresh breath', 'Safe for daily use'] },
    { icon: '💧', name: 'Purified Water', description: 'Pure, purified water as the base for a clean, hydrated mouth.', benefits: ['Keeps gums hydrated', 'Supports a clean mouth', '100% safe'] }
  ];
  function initIngredients() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-dw-ingredient]'));
    var desktop = document.querySelector('[data-dw-ing-desktop]');
    var mobile = document.querySelector('[data-dw-ing-mobile]');
    if (!btns.length) return;
    function activate(i) {
      var ing = INGREDIENTS[i];
      if (!ing) return;
      btns.forEach(function (b, j) {
        var on = j === i;
        b.style.backgroundColor = on ? 'rgb(13, 27, 42)' : 'rgb(255, 255, 255)';
        b.style.border = on ? '2px solid rgb(42, 181, 181)' : '2px solid rgb(226, 232, 240)';
        var name = b.querySelector('.text-sm.font-bold');
        var desc = b.querySelector('.text-xs');
        if (name) name.style.color = on ? 'rgb(255, 255, 255)' : 'rgb(13, 27, 42)';
        if (desc) desc.style.color = on ? 'rgba(255, 255, 255, 0.6)' : 'rgb(156, 163, 175)';
      });
      if (desktop) {
        var dE = desktop.querySelector('.text-4xl'); if (dE) dE.textContent = ing.icon;
        var dN = desktop.querySelector('h3'); if (dN) dN.textContent = ing.name;
        var dD = desktop.querySelector('p'); if (dD) dD.textContent = ing.description;
        var dB = desktop.querySelectorAll('span.text-sm.font-medium');
        Array.prototype.forEach.call(dB, function (s, k) { if (ing.benefits[k] != null) s.textContent = ing.benefits[k]; });
      }
      if (mobile) {
        var mD = mobile.querySelector('p'); if (mD) mD.textContent = ing.description;
        var mB = mobile.querySelectorAll('span.text-xs.font-medium');
        Array.prototype.forEach.call(mB, function (s, k) { if (ing.benefits[k] != null) s.textContent = ing.benefits[k]; });
        if (btns[i].parentNode) btns[i].parentNode.appendChild(mobile);
      }
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { activate(i); }); });
  }

  /* ---------- Rotating announcement bar (mobile) ---------- */
  var ANNOUNCE = ['🚚 Free shipping over $40', '⭐ 4.8/5 from 1,280+ happy pet parents', '🛡️ 30-day money-back guarantee', '🐾 Safe for dogs and cats'];
  function initAnnouncement() {
    var el = document.querySelector('[data-dw-announcement]');
    if (!el) return;
    var i = ANNOUNCE.indexOf(el.textContent.trim());
    if (i < 0) i = 0;
    setInterval(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateY(8px)';
      setTimeout(function () {
        i = (i + 1) % ANNOUNCE.length;
        el.textContent = ANNOUNCE[i];
        el.style.opacity = '1';
        el.style.transform = 'translateY(0px)';
      }, 300);
    }, 3000);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    initReveal();
    initGallery();
    initFaq();
    initBundles();
    initStickyBar();
    initCart();
    initTabs();
    initIngredients();
    initAnnouncement();
  });
})();
